<template>
    <div class="panel panel-default panel-dashboard">
        <loading-spinner v-if="data === null"/>

        <div v-else class="panel-body text-center">
            <div class="row">
                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data.held_meeting_count }} / {{ data.meeting_count }}
                    </p>

                    <p style="margin-bottom: 0">
                        Meetings
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data.opportunity_count }}
                    </p>

                    <p style="margin-bottom: 0">
                        Opportunities
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data.sales_count }} <small style="font-size: 24px;">{{ salesShare }} %</small>
                    </p>

                    <p style="margin-bottom: 0">
                        Sales
                    </p>
                </div>

                <div class="col-xs-6">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data.sales_value | price }}
                    </p>

                    <p style="margin-bottom: 0">
                        Sales Value
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {LoadingSpinner},

        props: {
            filters: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                data: null
            }
        },

        mounted() {
            this.load()
        },

        watch: {
            filters: {
                deep: true,
                handler: function () {
                    this.load()
                }
            }
        },

        computed: {
            salesShare() {
                if (this.data.meeting_count === 0) {
                    return 'N/A'
                }

                return Math.round(this.data.sales_count / this.data.meeting_count * 100)
            }
        },

        methods: {
            load() {
                http.post('/api/v1/reports/meeting-overview', this.filters)
                    .then(response => {
                        this.data = response.data.data
                    })
            }
        }
    }
</script>
